/*
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2025-04-27 10:40:23 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-07-16 11:58:47 +0800
 * @FilePath     : /ai-agent-lumina/src/utils/server/index.js
 * @Description  : axios
 */
/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from 'axios';
import { contentEnum } from './http-enum'
import { serialize } from '@/utils';
import { useUserStore } from '@/stores/modules/user.js'
import { useConfigStore } from '@/stores/modules/config.js'
import website from '@/config/website';
import crypto from '@/utils/crypto';
import { showToast } from 'vant';
// 全局未授权错误提示状态，只提示一次
let isErrorShown = false;

// 返回其他状态码
// axios.defaults.validateStatus = function (status) {
//   return status >= 200 && status <= 500; // 默认的
// };

const request = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API,
  withCredentials: true,
  timeout: 1000 * 60,
})

//http request拦截
request.interceptors.request.use(
  config => {
    // console.log('%c文件[index]MESSAGE%c当前行:40, config', 'color:#fff;background:#8dcbc3;padding: 5px 8px;border-radius:2px', 'color:#000;background:#f8d8b3;padding: 5px 8px;border-radius:2px', config)
    // 初始化错误提示状态
    isErrorShown = false;
    // 安全请求header
    config.headers['Blade-Requested-With'] = 'BladeHttpRequest';

    // 获取用户信息设置tenantId
    const userStore = useUserStore()
    // 优先从URL参数获取exhibitionId，URL参数优先级最高
    const urlExhibitionId = new URLSearchParams(window.location.search).get('exhibitionId');
    const tenantId = urlExhibitionId || userStore.tenantId || userStore.exhibitionId || '000000';
    // 统一使用tenant-id作为header名称
    config.headers['tenant-id'] = tenantId;

    // headers判断是否需要
    const authorization = config.authorization === false;
    config.headers['lang'] = userStore.lang || 'cn';

    // 始终设置Basic认证
    if (!authorization) {
      config.headers['Authorization'] = `Basic c2FiZXIzOnNhYmVyM19zZWNyZXQ=`;
    }
    // headers判断请求是否携带token
    const meta = config.meta || {};
    const isToken = meta.isToken === false;
    //判断传递数据是否加密
    const cryptoData = config.cryptoData === true;
    const token = userStore.token;
    // 当token存在且允许携带token时，设置Blade-Auth header
    if (token && !isToken) {
      config.headers['Blade-Auth'] = `bearer ${token}`
    }
    // 开启报文加密
    if (cryptoData) {
      if (config.params) {
        const data = crypto.encryptAES(JSON.stringify(config.params), crypto.aesKey);
        config.params = { data };
      }
      if (config.data) {
        config.text = true;
        config.data = crypto.encryptAES(JSON.stringify(config.data), crypto.aesKey);
      }
    }
    //headers中配置text请求
    if (config.text === true) {
      config.headers['Content-Type'] = 'text/plain';
    }
    if (config.type === 'file') {
      config.headers['Content-Type']  = 'multipart/form-data'
    }

    //headers中配置serialize为true开启序列化
    if (config.method === 'post' && meta.isSerialize === true) {
      config.data = serialize(config.data);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//http response拦截
request.interceptors.response.use(
  result => {
    const status = parseInt(result.data.code) || result.status;
    // 白名单
    const statusWhiteList = website.statusWhiteList || [];
    const message = result.data.message || '系统错误';
    const config = result.config;
    //如果在白名单里则自行catch逻辑处理
    if (statusWhiteList.includes(status)) return Promise.reject(result);

    // OAuth token 返回没有 code 字段，通过 access_token 判断成功
    if (result.data && result.data.access_token) {
      return result.data;
    }

    // 如果请求为非1000则默认统一处理
    if (status !== 1000) {
      setTimeout(() => showToast(message), 500)
      return Promise.reject(result);
    }

    const cryptoData = config.cryptoData === true;
    // 解析加密报文
    if (cryptoData) {
      result.data = JSON.parse(crypto.decryptAES(result.data, crypto.aesKey));
    }
    return result.data;
  },
  error => {
    const code = error.response.data?.code || error.response.status;
    const message = error.response.data?.message || error.response.statusText;
    showToast(`${code}: ${message}`)
    return Promise.reject(error.response);
  }
);


export const createApi = (url, method, data = null, option = {}, h = 'JSON') => {
  const defaultParam = {}
  // 默认参数
  const config = {
    url,
    method,
    ...option
  }
  if(method.toLocaleUpperCase() === 'GET') {
    config.params = Object.assign(data || {}, defaultParam, option?.params || {})
  } else {
    if(data || option?.data) config.data = Object.assign(data || {}, defaultParam, option?.data || {})
    if(option?.params) config.params = Object.assign(defaultParam, option?.params || {})
  }
  // 请求头处理
  if(Object.keys(contentEnum).indexOf(h) !== -1) {
    config.headers = {'Content-Type': contentEnum[h], ...(option?.headers || {} ), 'tenant-id': defaultParam.tenantId }
  } else {
    config.headers = {'Content-Type': contentEnum['JSON'], ...(option?.headers || {} )}
    console.warn(`h：尚未维护的请求头类型："${h}"，仅限[${Object.keys(contentEnum).join(' | ')}]请求头使用，已默认为JSON请求头，如需特殊处理，请在option.headers下进行配置。`)
  }
  return request(config)
};

export default request;
